import React, {Component} from 'react'
import {reduxForm, Field} from 'redux-form'
import {NavLink} from 'react-router-dom'


class BackOfficeReceiptCreateScreen extends Component {

    render() {
        const {error, handleSubmit} = this.props;
        return(<div className="col-md-12">
            <div className="panel panel-default panel-border">
            <div className="panel-body">
                <h2 className="title">Crea Ricevuta</h2>
            <form onSubmit={handleSubmit}>
                <div className="box">
                    <div className="row">
                        <div className="col-md-6 text-left">
                            <label>ID Abbonamento</label>
                            <Field component="input" name="parkingPassId" type="number" className="resident-login" required/>
                        </div>
                        <div className="col-md-6 text-left">
                            <label>Totale</label>
                            <Field component="input" name="total" type="number" className="resident-login" required/>
                        </div>
                    </div>
                    {this.props.loading && <div className="well">Creazione Ricevuta in Corso...</div> }

                    {this.props.receiptCreateError && <div className="panel panel-danger">
                        Errore nella creazione della ricevuta
                    </div>}

                    {this.props.receiptCreateSuccess && <div>
                        <div className="row">
                            <div className="col-md-4 col-md-offset-4 ">
                                <div className="contrassegno">
                                    <h4 className="contrassegno-h">Ricevuta creata correttamente!</h4>
                                    <p>
                                        <NavLink to={"/backoffice/receipts"} className="list-group-item menu-item" activeClassName={"active"}>Ricevute</NavLink>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>}
                    <p>
                        <button type="submit" className="btn btn-lg btn-green">
                            Crea Ricevuta
                        </button>
                    </p>
                </div>
            </form>
            </div>
            </div>
        </div>);
    }
}

export default reduxForm({
    form: 'backofficeReceiptCreate'
})(BackOfficeReceiptCreateScreen)


// WEBPACK FOOTER //
// ./src/screens/BackOfficeReceiptCreateScreen.js